import { useCallback, useState } from "react";

export function usePublishModal() {
    const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
    const [isPublishedSiteModalOpen, setIsPublishedSiteModalOpen] = useState(false);
    const [isBillingModalOpen, setIsBillingModalOpen] = useState(false);

    const togglePublishModal = useCallback(() => setIsPublishModalOpen((p) => !p), []);
    const openPublishModal = useCallback(() => setIsPublishModalOpen(true), []);
    const closePublishModal = useCallback(() => setIsPublishModalOpen(false), []);

    const togglePublishedSiteModal = useCallback(() => setIsPublishedSiteModalOpen((p) => !p), []);
    const openPublishedSiteModal = useCallback(() => setIsPublishedSiteModalOpen(true), []);
    const closePublishedSiteModal = useCallback(() => setIsPublishedSiteModalOpen(false), []);

    const toggleBillingModal = useCallback(() => setIsBillingModalOpen((p) => !p), []);
    const openBillingModal = useCallback(() => setIsBillingModalOpen(true), []);
    const closeBillingModal = useCallback(() => setIsBillingModalOpen(false), []);

    return {
        isPublishModalOpen,
        togglePublishModal,
        openPublishModal,
        closePublishModal,

        isPublishedSiteModalOpen,
        togglePublishedSiteModal,
        openPublishedSiteModal,
        closePublishedSiteModal,

        isBillingModalOpen,
        toggleBillingModal,
        openBillingModal,
        closeBillingModal,
    };
}
